export const sliderConstants = {
  HOME_SLIDER_REQUEST: 'HOME_SLIDER_REQUEST',
  HOME_SLIDER_SUCCESS: 'HOME_SLIDER_SUCCESS',
  HOME_SLIDER_FAILURE: 'HOME_SLIDER_FAILURE'
};
